const appEnvironment = process.env.REACT_APP_ENVIRONMENT;
let baseURL;

if (!process.env.REACT_APP_API_BASE_URL) {
  switch (appEnvironment?.trim()) {
    case "local":
      baseURL = process.env.REACT_APP_LOCAL_API_BASE_URL;
      break;
    case "dev":
      baseURL = process.env.REACT_APP_DEV_API_BASE_URL;
      break;
    case "staging":
      baseURL = process.env.REACT_APP_STAGING_API_BASE_URL;
      break;
    case "prod":
      baseURL = process.env.REACT_APP_PROD_API_BASE_URL;
      break;
    default:
      baseURL = process.env.REACT_APP_DEV_API_BASE_URL;
  }
} else {
  baseURL = process.env.REACT_APP_API_BASE_URL;
}

export const constants = {
   baseURL
   //baseURL: 'https://portal.yeuls.co.il/api/v1', // prop
   //baseURL: 'https://yeuls-portal-dev.herokuapp.com/api/v1', // dev
  //baseURL: 'http://localhost:3000/api/v1', // local server
};
